"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var utils_1 = require("./utils");
var Abm = function (_a) {
    var size = _a.size, title = _a.title, theme = _a.theme, _b = _a.color, color = _b === void 0 ? utils_1.themeToColor(theme) : _b, svgProps = __rest(_a, ["size", "title", "theme", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', style: __assign({ color: color }, svgProps.style), viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "abm-app-icon" },
            react_1.default.createElement("path", { d: "M11.2236 24.2302L13.7249 21.331C13.2129 20.4841 13.0583 19.4068 13.4561 18.4062C13.9809 17.0462 15.3036 16.2505 16.7532 16.3412C17.1244 16.3668 17.4849 16.4564 17.8188 16.5982L20.3319 13.6862C19.6001 13.2244 18.7799 12.8905 17.9457 12.7241C18.8439 11.634 22.0769 7.90063 22.0769 7.90063L19.2161 5.33423C19.2161 5.33423 14.9057 10.4532 13.4572 12.2366C12.5975 13.3012 11.7249 14.3668 10.8663 15.4313C9.76227 16.7913 9.31213 18.7796 9.53187 20.5246C9.7228 21.9486 10.3393 23.219 11.2236 24.2324V24.2302Z", fill: "#00B2AE" }),
            react_1.default.createElement("path", { d: "M22.9624 16.7253C22.667 16.0063 22.2179 15.3397 21.6654 14.7754L19.1779 17.6618C19.6782 18.3285 19.9342 19.1882 19.8062 20.0607C19.563 21.793 17.8435 23.217 16.06 22.8831C15.6632 22.8319 15.3038 22.7039 14.9688 22.5237L12.5059 25.3717C14.1091 26.4874 16.1486 26.9621 18.1752 26.4746C22.396 25.4485 24.7438 20.7018 22.9614 16.7242L22.9624 16.7253Z", fill: "currentcolor" }))));
};
exports.default = Abm;
